const styles = (theme) => ({
  dialogTitle: {
    padding: "9 24",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  root:{
    zIndex:"2000"
  },
  dialog: {
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    minWidth: "calc(100% - 10px)",
    minHeight: "calc(100% - 10px)",
    fontWeight: "600",
  },
  dialogWrapper: {},
  dialogContent: {
    overflowX: "hidden",
    padding: "10px 24px",
  },
  closeButton: {
    color: theme.iconColor,
    marginLeft: 18,
    padding: 0,
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
    top: "19px",
    display: "flex",
    alignItems: "center"
  },
  dialogTitlestyle: {
    padding: 0,
    marginBottom: "25px",
  },
  resizePickInfo: {
    marginRight: '380px'
  },
  grayBar: {
    height: 1,
    backgroundColor: theme.AppBGColor,
    marginBottom: 14,
  },
  drawerRootClass: {
    left: 'auto',
    zIndex: 2001 //should be more than z-index of pickupInfo popup
  },
  dialogRootClass: {
    zIndex: 2002 //more than pro info drawer
  }
});

export default styles